import { detectMobile } from '@/components/helpers/mobile-helper';

export default {
  menuOpen: false,
  menuGroupingOpen: false,
  menuGroupingTop: 0,
  menuReportTabsOpen: false,
  menuReportTabsTop: 0,
  desktopViewForced: false,
  desktopViewForcedCurrent: false,
  isMobile: detectMobile(), //no logout cleanup
}
